/**
 * @generated SignedSource<<779f8541a0511ddcc6c909379ca73ad4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RegionEditMain_region$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "RegionEditMain_region";
};
export type RegionEditMain_region$key = {
  readonly " $data"?: RegionEditMain_region$data;
  readonly " $fragmentSpreads": FragmentRefs<"RegionEditMain_region">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RegionEditMain_region",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Region",
  "abstractKey": null
};

(node as any).hash = "967d9f3d71069b659698fb709747d55b";

export default node;
